<template>
  <button type="button" @click="division.selected = !division.selected"
          v-bind:class="{btn: true, 'btn-outline-primary': true, active: division.selected}">
    <p class="user">({{ division.id }}) {{
        division.user && division.user.short_name || 'Не назначен'
      }}</p>
    <p class="stores" v-if="division.cities.length">
                    <span v-for="(city, i) in division.cities">{{
                        i !== 0 ? ', ' : ''
                      }} {{ city?.object_id === 0 ? 'Почта' : $AllCities[city?.object_id]?.name }}</span>
      (<span v-for="(store, i) in division.stores">{{
        i !== 0 ? ', ' : ''
      }}{{ $AllStores[store?.object_id]?.short_title }}</span>)
    </p>
  </button>
</template>
<script>

export default {
  props: ['division'],
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores'];
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
  },
}

</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
